import React from "react";
import {
  Col,
  Container,
  Row,
} from "react-bootstrap";
import Fade from "react-awesome-reveal";

const BuildYourdream = (props) => {
  return (
    <>
      <Container style={{width: "1332px"}}>
        <Row className="common-styling">
          <Col xs="12" className="mb-4">
            <Fade direction="up">
              <h1>Build your dream</h1>
            </Fade>
            <Fade direction="up">
              <p>
                Premium domains can bring GREAT POWER and value to your business
                with a brilliant and profitable idea. It's the KEY to building
                your EMPIRE and VERY VALUABLE once you understand its TRUE VALUE.
              </p>
            </Fade>
          </Col>
          <Col xs="12">
            <div className="how-it-works-card">
              <Fade direction="up">
                <h2 className="breed">'If you build it.....they will come'</h2>
              </Fade>
              <Fade direction="up">
                <p>
                  How much is a domain worth? How much would it cost to OPEN and
                  OPERATE a physical store in the real world for 1 year? For 3
                  years? 10 years? How wide an area can you service?
                </p>
              </Fade>
              <Fade direction="up">
                <h2 className="breed">
                  Never ignore the size of the audience - The value of GREAT .coms
                  can only skyrocket
                </h2>
              </Fade>
              <Fade direction="up">
                <p>
                  There are 7.9 Billion in (2022) people on the planet! 8 billion
                  in (2023) 9 billion in (2037) 10 billion by (2057)
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  When people start examining the cost of bricks and mortar, they
                  begin to understand why a great domain name is so powerful. They
                  will make your hard work and dedication rewarded a lot easier
                  and give you a competitive advantage INCREASING SALES and
                  reaching your goals.
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Every business is now focused on doing business online. Their
                  entire future and energy and dollars are headed online. There is
                  no limit!
                </p>
              </Fade>
            </div>
          </Col>
          <Col xs="12" className="mt-4">
            <div className="how-it-works-card">
              <Fade direction="up">
                <h2 className="breed">
                  The dot-com franchise is the largest franchise ever known.
                  Owning the right domain is an essential foundation for becoming
                  successful and knocking out your competition.
                </h2>
              </Fade>
              <Fade direction="up">
                <p>
                  The dot-com franchise is the largest franchise ever known.
                  Owning the right domain is an essential foundation for becoming
                  successful and knocking out your competition.
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Once you become a member and start networking with top-class
                  talents with mind-blowing IDEAS it will be a HUGE LIFE CHANGER
                  building your dream and combined with very powerful weapons and
                  armed with credibility, has no limit. To compete against a great
                  company you need to own something that others will always NEED,
                  WANT, and DESIRE
                </p>
              </Fade>
              <Fade direction="up">
                <h2 className="breed">Friendships can be the foundation of a great business</h2>
              </Fade>
              <Fade direction="up">
                <p>
                  To be successful you need to be in the CREATIVE ZONE with a team
                  dancing to the same tune. Stud makes you learn to do business
                  musical chairs, picking the best and dropping the rest. It will
                  make you smile again and feel on top of the world. That's the
                  zone you need to be in and the DOORS OF OPPORTUNITY will OPEN.
                </p>
              </Fade>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default BuildYourdream;
